import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { showToast,ToastMessage } from '../../Shared/ToastMessage';
import { baseUrl } from '../../../api/common';

const GstTypeAdd = ({fetchGstTypeData,addPopupStatus, handleAddPopup, eventType, updateData}) => {

  const [updateId, setUpdateId] = useState("");

  const [formValues, setFormValues] = useState({
    gst_type_name: ''
  });

  const [errors, setErrors] = useState({
    gstTypeName: ''
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setFormValues({ ...formValues, flag: file }); 
  };

  const validate = () => {
    const newErrors = {
      gstTypeName: ''
    };  
    if (!formValues.gst_type_name.trim()) {
      newErrors.gstTypeName = 'Gst type cannot be empty';
    }  
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };  

  const clearInputValues = () => {
    setErrors({
      gstTypeName: ''
    });
    setFormValues({
      gst_type_name: ''
    });
    handleAddPopup(false);
  };  

  const addUpdateGstType = async () => {
    if (validate()) {
      console.log('Post Data:', formValues);   
      try {
        const requestData = {
          ...formValues,
          ...(eventType === "Update" && { id: updateId }),
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/add_gst_type`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchGstTypeData();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  useEffect(() => {
    if (eventType === "Update" && updateData) {
      console.log("Update Data:", updateData);
      setUpdateId(updateData.id);
      setFormValues({
        gst_type_name: updateData.gst_type_name || ''
      });
    }else{
      setErrors({
        gstTypeName: ''
      });
      setFormValues({
        gst_type_name: ''   
      });    
    }
  }, [eventType, updateData, addPopupStatus]);

  return (
    <>
    <ToastMessage/>    
    {addPopupStatus && (
      <div
        className={`extraspace_search_div search_div${addPopupStatus ? ' open' : ''}`}
      >
        <div className="card member_master_sidebar_scrool">
          <div className="member_edit_pop_flex mb-3 text-end">
            <h3>{eventType} GST Type</h3>
            <div className="input-group-append">
              <span
                onClick={() => clearInputValues()}
                className="search_toggle btn btn-danger"
              >
                <i className="fa fa-times" />
              </span>
            </div>
          </div>
          <div className="table-responsive">
            <div className="body application_body_side">
              <div>             
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group pos_relative">
                        <label>GST Type</label>
                        <input
                          type="text"
                          className={`form-control ${errors.gstTypeName?"red_border":''}`}
                          value={formValues.gst_type_name}
                          onChange={(e) => handleInputChange('gst_type_name', e.target.value)} 
                          required
                        />
                        {errors && (                          
                            <p className="text-danger pos_abos">{errors.gstTypeName}</p>                          
                        )}
                      </div>

                    </div>
                    <div className="col-md-12 member_button_flex">
                      <button onClick={() => addUpdateGstType()} className="btn btn-outline-info">
                      {eventType}
                      </button>
                      <a
                        onClick={() => clearInputValues()}
                        className="btn btn-outline-danger"
                      >
                        Close
                      </a>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
};

export default GstTypeAdd;
